export type Action =
    | AppAction
    | ListAction
    | MembersAction
    | MessageAction
    | RoomAction
    | SearchAction
    | SettingsAction
    | UserAction
    | ChatAction
    | RoomHelperAction

export const enum AppAction {
    RESUME_SOCKET_CONNECTION = 'RESUME_SOCKET_CONNECTION',
    PAUSE_SOCKET_CONNECTION = 'PAUSE_SOCKET_CONNECTION',
    PUBLISH_WEBCAM = 'PUBLISH_WEBCAM',
    BROWSER_RELOAD = 'BROWSER_RELOAD',
    SET_DARK_MODE = 'SET_DARK_MODE',
    SET_AGE_CHECK = 'SET_AGE_CHECK',
    FULL_WINDOW = 'FULL_WINDOW',
}

export const enum AppStateType {
    ALERTS = 'alerts',
    APP = 'app',
    AUTHENTICATION = 'authentication',
    MYWEBCAM = 'myWebcam',
    SESSION = 'session',
    TIP_DEFAULTS = 'tipDefaults',
    TOKENS = 'tokens',
}

export const enum ChatCommandEvent {
    GENERATE_COMMANDS = 'GENERATE_COMMANDS',
}

export const enum ConfirmationType {
    Friend,
    Bookmark,
}

// moved from /utilities/mfcLogic/ueopts.ts (to avoid circular dependency)
export const enum DisplayUeopt {
    text = 'text',
    /** avatar */
    default = 'default',
    preview = 'preview',
    detailed = 'detailed',
}

export enum PMPlaySoundOnUeopt {
    allMessages = 'txrx',
    receivedMessage = 'rx',
    onlyOnFirstMessage = 'on_first',
    none = 'none',
}

export const enum DisplayModeFriends {
    list = 'list',
    /** avatar */
    default = 'default',
    preview = 'preview',
    detailed = 'detailed',
}

export const enum DrawerHeight {
    Full = 'full',
    Limited = 'limited',
    Half = 'half',
}

export const enum EMOJI_ANCHOR_LOCATIONS {
    top = 'top', // default
    bottom = 'bottom', // used for Drawers
}

export const enum EventAction {
    APP = 'APP',
    MEMBERS = 'MEMBERS',
    LISTS = 'LISTS',
    MESSAGE = 'MESSAGE',
    ROOM = 'ROOM',
    ROOM_HELPER = 'ROOM_HELPER',
    SEARCH = 'SEARCH',
    UPDATE_SETTINGS = 'UPDATE_SETTINGS',
    USERS = 'USERS',
    ARCHIVE = 'ARCHIVE',
}

export const enum EventType {
    PARTICIPANTS = 'PARTICIPANTS',
    ACTIONS = 'ACTIONS',
    APP = 'APP',
    FCS = 'FCS',
    HEALTH = 'HEALTH',
    INDEX = 'INDEX',
    LISTS = 'LISTS',
    PING = 'PING',
    PONG = 'PONG',
    READY = 'READY',
    // READY_FOR_DATA = 'READY_FOR_DATA',
    SEARCH = 'SEARCH',
    SERVER_SIDE_USER = 'SERVER_SIDE_USER',
    SERVER_SIDE_FEATURED_MODELS = 'SERVER_SIDE_FEATURED_MODELS',
    SERVER_SIDE_MODEL_LIST = 'SERVER_SIDE_MODEL_LIST',
    SETTINGS = 'SETTINGS',
    USERS = 'USERS',
    FCTYPE_LOGIN = 'FCTYPE_LOGIN',
    INITIALIZE = 'INITIALIZE',
    CHAT = 'CHAT',
    MEMBERS = 'MEMBERS',
}

export const enum ExploreCategory {
    Popular = 'Popular',
    Trending = 'Trending',
    MissMFC = 'MissMFC',
    NewModels = 'NewModels',
    GroupShows = 'GroupShows',
    PrivateShows = 'PrivateShows',
    ClubShows = 'ClubShows',
}

export const enum GridLocation {
    Home = 'home',
    Search = 'search',
    Room = 'room',
    Friends = 'friends',
}

export const enum HEALTH {
    DISCONNECTED = 'DISCONNECTED',
    CONNECTING = 'CONNECTING',
    CONNECTED = 'CONNECTED',
    ERROR = 'CANT_CONNECT',
    PAUSED = 'PAUSED',
    // ACTIVE = 'ACTIVE',
    // INACTIVE = 'INACTIVE',
    // INITIALIZING = 'INITIALIZING',
    // NEEDS_RELOAD = 'NEEDS_RELOAD',
    // RECONNECTING = 'RECONNECTING',
    // RECONNECT_CANCELLED = 'RECONNECT_CANCELLED',
    // RECONNECT_MANUAL = 'RECONNECT_MANUAL',
    // STARTING = 'STARTING',
    // RESTARTING = 'RESTARTING',
}

export const enum LayoutEvent {
    CHANGE = 'CHANGE',
    LAYOUT_CHANGE = 'LAYOUT_CHANGE',
    PORTAL_CHANGE = 'PORTAL_CHANGE',
    PORTAL_DIMENSIONS_CHANGE = 'PORTAL_DIMENSIONS_CHANGE',
}

export const enum ListAction {
    SUBSCRIBE_UPDATES = 'SUBSCRIBE_UPDATES',
    UNSUBSCRIBE_UPDATES = 'UNSUBSCRIBE_UPDATES',
    DELETE = 'DELETE',
    INSERT = 'INSERT',
    MODIFY = 'MODIFY',
    REMOVE = 'REMOVE',
    RESET = 'RESET',
}

export const enum ChatAction {
    ARCHIVE = 'ARCHIVE',
}

export const enum ListType {
    ALERTS = 'ALERTS',
    BOOKMARKED_FRIENDS_BROADCASTING = 'BOOKMARKED_FRIENDS_BROADCASTING',
    BOOKMARKED_FRIENDS_OFFLINE = 'BOOKMARKED_FRIENDS_OFFLINE',
    BOOKMARKED_FRIENDS_ONLINE = 'BOOKMARKED_FRIENDS_ONLINE',
    BOOKMARKED_FRIENDS_ONLINE_NOT_BROADCASTING = 'BOOKMARKED_FRIENDS_ONLINE_NOT_BROADCASTING',
    BOOKMARKS = 'BOOKMARKS',
    BOOKMARKS_BROADCASTING = 'BOOKMARKS_BROADCASTING',
    BOOKMARKS_OFFLINE = 'BOOKMARKS_OFFLINE',
    BOOKMARKS_ONLINE = 'BOOKMARKS_ONLINE',
    BOOKMARKS_ONLINE_NOT_BROADCASTING = 'BOOKMARKS_ONLINE_NOT_BROADCASTING',
    BROADCASTING_MODELS = 'BROADCASTING_MODELS',
    DEFAULT = 'DEFAULT',
    DEFAULT_PUBLIC = 'DEFAULT_PUBLIC',
    FRIENDS = 'FRIENDS',
    LAST_VIEWED = 'LAST_VIEWED',
    MEMBER_FRIENDS_OFFLINE = 'MEMBER_FRIENDS_OFFLINE',
    MEMBER_FRIENDS_ONLINE = 'MEMBER_FRIENDS_ONLINE',
    MISSMFC = 'MISSMFC',
    MISSMFC_ONLINE = 'MISSMFC_ONLINE',
    MODEL_FRIENDS = 'MODEL_FRIENDS',
    MODEL_FRIENDS_BROADCASTING = 'MODEL_FRIENDS_BROADCASTING',
    MODEL_FRIENDS_OFFLINE = 'MODEL_FRIENDS_OFFLINE',
    MODEL_FRIENDS_ONLINE = 'MODEL_FRIENDS_ONLINE',
    MODEL_FRIENDS_ONLINE_NOT_BROADCASTING = 'MODEL_FRIENDS_ONLINE_NOT_BROADCASTING',
    MODELS_YOU_MAY_LIKE = 'MODELS_YOU_MAY_LIKE',
    NEWMODELS = 'NEWMODELS',
    POPULAR = 'POPULAR',
    PREMIUM_OR_MODEL_FRIENDS = 'PREMIUM_OR_MODEL_FRIENDS',
    SEARCH = 'SEARCH',
    MODEL_TRENDING = 'MODEL_TRENDING',
    MODEL_GROUP_SHOWS = 'MODEL_GROUP_SHOWS',
    PINNED_MODEL_TRENDING = 'PINNED_MODEL_TRENDING',
    PINNED_MODEL_POPULAR = 'PINNED_MODEL_POPULAR',
    PINNED_MODEL_MISS_MFC = 'PINNED_MODEL_MISS_MFC',
    PINNED_MODELS_YOU_MAY_LIKE = 'PINNED_MODELS_YOU_MAY_LIKE',
    PINNED_MODEL_RECENTLY_VISITED = 'PINNED_MODEL_RECENTLY_VISITED',
    LATEST_PM_TIMESTAMP = 'LATEST_PM_TIMESTAMP',
    LATEST_PM_UNREAD = 'LATEST_PM_UNREAD',
    MODEL_CLUB_SHOWS = 'MODEL_CLUB_SHOWS',
    MODEL_PRIVATE_SHOWS = 'MODEL_PRIVATE_SHOWS',
}

export const enum MessageAction {
    SEND_TYPING_INDICATOR = 'SEND_TYPING_INDICATOR',
    RESUME_UNREAD_COUNT = 'RESUME_UNREAD_COUNT',
    PAUSE_UNREAD_COUNT = 'PAUSE_UNREAD_COUNT',
    CLEAR_UNREAD_COUNT = 'CLEAR_UNREAD_COUNT',
    LOAD_PMS_USER_LIST = 'LOAD_PMS_USER_LIST',
    LOAD_PM_PREVIEW = 'LOAD_PM_PREVIEW',
    SEND_MESSAGE = 'SEND_MESSAGE',
    LOAD_ARCHIVE = 'LOAD_ARCHIVE',
    VIDEO_FEED = 'VIDEO_FEED',
    LOAD_PMS = 'LOAD_PMS',
    HIDE = 'HIDE',
}

export const enum MessageEvent {
    ACTIVE_MESSAGE = 'ACTIVE_MESSAGE',
    LIST = 'LIST',
    LOADING = 'LOADING',
    MESSAGE = 'message',
    MESSAGES = 'messages',
    SEARCH = 'search',
}

export const enum RoomAction {
    CLUBSHOW_INFO = 'CLUBSHOW_INFO',
    // END_SESSION = 'END_SESSION',
    FORGET_ROOM = 'FORGET_ROOM',
    REGISTER_ROOM = 'REGISTER_ROOM',
    REQUEST_GROUP = 'REQUEST_GROUP',
    REQUEST_PRIVATE = 'REQUEST_PRIVATE',
    REQUEST_VOYEUR = 'REQUEST_VOYEUR',
    SEND_MESSAGE = 'SEND_MESSAGE',
    SEND_XMESG = 'SEND_XMESG',
    SUBSCRIBE = 'SUBSCRIBE',
    STREAM_PUBLIC_SHOW = 'STREAM_PUBLIC_SHOW',
    STREAM_CLUBSHOW = 'STREAM_CLUBSHOW',
    UNSUBSCRIBE = 'UNSUBSCRIBE',
    // UNSUBSCRIBE_CLUBSHOW = 'UNSUBSCRIBE_CLUBSHOW',
    SWAP = 'SWAP',
}

export const enum RoomEvent {
    STATE = 'STATE',
    PREVIEWS = 'PREVIEWS',
    RESTORED = 'RESTORED',
    PIN_ROOM = 'PIN_ROOM',
    PIN_HELPER_ID = 'PIN_HELPER_ID',
}

export const enum RoomHelperAction {
    SEND_COMMAND = 'ROOM_HELPER_SEND_COMMAND',
}

export const enum RoomHelperEvent {
    STATE = 'ROOM_HELPER_STATE',
}

export const enum SearchAction {
    SEARCH = 'SEARCH',
    SEARCH_LIST = 'SEARCH_LIST',
}

export const enum SearchEvent {
    /** set/update the search session state */
    UPDATE_HISTORY = 'UPDATE_HISTORY',
    /** get the list filter results back from worker */
    RESULTS_LIST = 'RESULTS_LIST',
    /** set/update the search query state */
    UPDATE_QUERY = 'UPDATE_QUERY',
    /** send the list query to the worker to compute */
    QUERY_LIST = 'QUERY_LIST',
    // /** set/update the search referrer state */
    // REFERRER = 'REFERRER',
    /** get the results back from worker */
    RESULTS = 'RESULTS',
    /** set/update search loading state */
    LOADING = 'LOADING',
    /** send the query to the worker to compute */
    QUERY = 'QUERY',
}

export const enum SecureStateType {
    AGE_VERIFICATION = 'ageVerification',
    DISPLAY_CONFIG = 'displayConfig',
    IMAGE_SECURITY_CONFIG = 'imageSecurityConfig',
}

export const enum SettingsAction {
    UPDATE = 'UPDATE',
}

export const enum SettingsEvent {
    SAVE = 'SAVE',
}

export const enum SettingsType {
    DEFAULT = 'DEFAULT',
    MY_ACCOUNT = 'MY_ACCOUNT',
    MY_WEBCAM = 'MY_WEBCAM',
    NEWS_NOTIFICATIONS = 'NEWS_NOTIFICATIONS',
    PRIVACY = 'PRIVACY',
    ROOM = 'ROOM',
}

export const enum SortOrder {
    ASC = 'asc',
    DESC = 'desc',
}

export const enum UserAction {
    GET_ALL_USERS = 'GET_ALL_USERS',
    ADD_BOOKMARK = 'ADD_BOOKMARK',
    ADD_FRIEND = 'ADD_FRIEND',
    ADD_IGNORE = 'ADD_IGNORE',
    ADD_NOTE = 'ADD_NOTE',
    CHANGES = 'CHANGES',
    DELETE_NOTE = 'DELETE_NOTE',
    HIDE_USER = 'HIDE_USER',
    LOAD_EXTRAS = 'LOAD_EXTRAS',
    LOAD_SOCIAL_MEDIA = 'LOAD_SOCIAL_MEDIA',
    LOOKUP_USER = 'LOOKUP_USER',
    REMOVE_BOOKMARK = 'REMOVE_BOOKMARK',
    REMOVE_FRIEND = 'REMOVE_FRIEND',
    REMOVE_IGNORE = 'REMOVE_IGNORE',
    SAVE_NOTE = 'SAVE_NOTE',
    SEARCH_NOTES = 'SEARCH_NOTES',
    SOCKET_LOOKUP_USER = 'SOCKET_LOOKUP_USER',
    UNHIDE_USER = 'UNHIDE_USER',
    SUBSCRIBE_UPDATES = 'SUBSCRIBE_UPDATES',
    UNSUBSCRIBE_UPDATES = 'UNSUBSCRIBE_UPDATES',
    SUBSCRIBE_ALERTS = 'SUBSCRIBE_ALERTS',
    UNSUBSCRIBE_ALERTS = 'UNSUBSCRIBE_ALERTS',
    ALERTS = 'ALERTS',
    RECOVER_FROM_KICK = 'RECOVER_FROM_KICK',
    MESSAGES = 'MESSAGES',
    SET_MODELS_REQUESTED = 'SET_MODELS_REQUESTED',
    SET_MODELS_LOADED = 'SET_MODELS_LOADED',
}

export const enum UserEvent {
    ADD_NOTE = 'ADD_NOTE',
    BROADCASTING = 'BROADCASTING',
    DELETE_NOTE = 'DELETE_NOTE',
    LOAD_EXTRAS = 'LOAD_EXTRAS',
    LOOKUP = 'LOOKUP',
    SAVE_NOTE = 'SAVE_NOTE',
    SEARCH_NOTES = 'SEARCH_NOTES',
    SOCKET_LOOKUP = 'SOCKET_LOOKUP',
    UPDATE = 'UPDATE',
    ALL_USERS = 'ALL_USERS',
    MODELS_REQUESTED = 'MODELS_REQUESTED',
    MODELS_LOADED = 'MODELS_LOADED',
    ME_ID = 'ME_ID',
}

export const enum VideoEvent {
    AVATAR = 'avatar',
    DIMENSIONS = 'dimensions',
    INITIALIZING = 'initializing',
    INSTANCE = 'instance',
    PLAYING = 'playing',
    SNAP = 'snap',
}

// ordered by override priority
export const enum VideoType {
    ModelTile,
    FloatingPreview,
    StickyPreview,
    PinnedRoom,
    PinnedPm,
    Room,
    Menu,
}

export enum TokenPurchasePanes {
    iframe = 'iframe',
    landing = 'landing',
    wire = 'wire',
}

export enum FloaterPageState {
    FULL_WINDOW = 'FULL_WINDOW',
    LANDSCAPE = 'LANDSCAPE',
    LANDSCAPE_EXPANDED_NAV = 'LANDSCAPE_EXPANDED_NAV',
    LANDSCAPE_EXPANDED_SIDEBAR = 'LANDSCAPE_EXPANDED_SIDEBAR',
    LANDSCAPE_EXPANDED_ALL = 'LANDSCAPE_EXPANDED_ALL',
    PORTRAIT = 'PORTRAIT',
    PORTRAIT_LANDSCAPE_MEDIAN = 'PORTRAIT_LANDSCAPE_MEDIAN',
    PORTRAIT_EXPANDED_SIDEBAR = 'PORTRAIT_EXPANDED_SIDEBAR',
    LANDSCAPE_CONTENT = 'LANDSCAPE_CONTENT',
    LANDSCAPE_EXPANDED_NAV_CONTENT = 'LANDSCAPE_EXPANDED_NAV_CONTENT',
    LANDSCAPE_EXPANDED_SIDEBAR_CONTENT = 'LANDSCAPE_EXPANDED_SIDEBAR_CONTENT',
    LANDSCAPE_EXPANDED_ALL_CONTENT = 'LANDSCAPE_EXPANDED_ALL_CONTENT',
    PORTRAIT_CONTENT = 'PORTRAIT_CONTENT',
    PORTRAIT_EXPANDED_SIDEBAR_CONTENT = 'PORTRAIT_EXPANDED_SIDEBAR_CONTENT',
}

export enum ModalEvent {
    UPDATE_DIALOG = 'update_dialog',
    UPDATE_DRAWER = 'update_drawer',
    UPDATE_CONFIRMATION = 'update_confirmation',
    UPDATE_FLOATER = 'update_floater',
    UPDATE_FLOATING_ROOM = 'update_floating_room',
    UPDATE_QUICK_MENU = 'update_quick_menu',
    UPDATE_MODAL_STACK = 'update_modal_stack',
}
export enum ModalKind {
    Dialog = 'dialog',
    Drawer = 'drawer',
    Confirmation = 'confirmation',
    Floater = 'floater',
    FloatingRoom = 'floating_room',
    QuickMenu = 'quick_menu',
}

export enum FloaterSize {
    Small,
    Medium,
    Large,
    Fullscreen,
}

export enum RoomView {
    Room = 0,
    PM = 1,
    Profile = 2,
}

export enum ViewMode {
    Normal = 0,
    FullWindow = 1,
    Theater = 2,
}
export enum SnapSize {
    small = '341x192',
    medium = '427x240',
    large = '853x480',
}
export enum TimerEvent {
    STATE = 'state',
}

export enum KeyEvent {
    Keydown = 'keydown',
    // Keyup = 'keyup',
    // Keypress = 'keypress',
}

export enum MailBoxType {
    inbox = 'inbox',
    sent = 'sent',
}

export enum MymlEvent {
    UPDATE_RESULTS = 'update_results',
}

export enum MYML_LOCATIONS {
    menu = 'menu',
    profile = 'profile',
    recommendationPage = 'recommendationPage',
    room = 'room',
}

export enum MYML_SEARCH_TYPES {
    single = 'single',
    multiple = 'multiple',
}

export enum RoomHistoryEvent {
    append_month = 'append_month',
}

export enum TippedModelsEvent {
    update = 'update',
}

export enum SidebarEvent {
    SETTING = 'setting',
    STATE = 'state',
}
export enum SidebarType {
    Friends = 'friends',
    Participants = 'participants',
}

export enum WhiteboardEvent {
    UPDATE = 'update',
}

export enum LoungeOptions {
    off = 0,
    autoClick = 1,
    noPreviews = 2,
    autoClickWithPreviews = 3,
}

export enum ColorScheme {
    dark = 'dark',
    light = 'light',
    system = 'system',
}

export enum GatedDisplayModes {
    preview = 'preview',
    hideEverything = 'hide',
}

export const enum MembersAction {
    SUBSCRIBE = 'SUBSCRIBE',
    UNSUBSCRIBE = 'UNSUBSCRIBE',
    REFRESH = 'REFRESH',
    CREATE_ROOM = 'CREATE_ROOM',
    CLOSE_ROOM = 'CLOSE_ROOM',
    ROOM_LIST = 'ROOM_LIST',
    WEBCAMS = 'WEBCAMS',
    WEBCAMS_ERROR = 'WEBCAMS_ERROR',
}
